The application method that EJP should select for the hirer.

Currently, the following apply type codes are defined:

- `soa`
- `linkout`
